import { render, staticRenderFns } from "./releaseOverview.vue?vue&type=template&id=f82be70c&scoped=true&"
import script from "./releaseOverview.vue?vue&type=script&lang=js&"
export * from "./releaseOverview.vue?vue&type=script&lang=js&"
import style0 from "./releaseOverview.vue?vue&type=style&index=0&id=f82be70c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f82be70c",
  null
  
)

export default component.exports